import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  width: 35%;
  margin: auto;
  z-index: 100;
  position: relative;
  margin-top: 1.4rem;
  align-items: center;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 80%;
    margin-top: 4rem;
  }
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const StyledInput = styled.input`
  border: 2px solid #ecf0f1;
  padding: 1.2rem 0rem 1.2rem 1.3rem;
  width: 97%;
  font-size: 19px;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px #00000029;
  &:focus {
    outline: none;
  }
  @media (max-width: 768px) {
    width: 97%;
  }

  &::placeholder {
    font-size: 1.3rem;
    font-weight: 600;
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
`;

export const Label = styled.label`
  color: #ffffff;
  margin: 2rem;
  font-size: 24px;
  font-family: "Montserrat";
`;

export const ErrorLabel = styled.label`
  color: red;
  margin: 2rem;
  font-size: 16px;
  font-weight: 800;
  font-family: "Montserrat";
`;

export const FindContainer = styled.div`
  background: #3772ff;
  position: absolute;
  right: 0.25rem;
  top: 4px;
  cursor: pointer;
  height: auto;
  box-shadow: 0px 1px 6px #00000024;
  border-radius: 2rem;
  padding: 1.1rem 1.9rem;
  @media (max-width: 768px) {
    right: 0.025rem;
    padding: 1.1rem;
  }
  span {
    font-size: 1.1rem;
    color: #fff;
    font-weight: bold;
  }
`;
